import styled from 'styled-components/macro'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

export const BookAttractionWrapper = styled(Box)`
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 8px;
    img {
        max-height: 40px;
    }

    @media ${respondAbove.xl} {
        > div:nth-child(2) {
            max-width: 561px;
        }
        img {
            max-height: 64px;
        }
    }
`
